export const isMinibagVisible = () => {
  const element = document.querySelector('[data-testid=Checkout-shopping-mini-bag-fading-wrapper]');
  if (!element) {
    return false;
  }

  return window.getComputedStyle(element).visibility === 'visible';
};
